<div class="flexholder">
  <div class="extractOptions">


    <kendo-floatinglabel text="Extract Name">
      <kendo-combobox
        [data]="savedExtractsList"
        [(ngModel)]="dataItem"
        [valueField]="'id'"
        [textField]="'name'"
        [placeholder]=""
        [allowCustom]="true"
        (valueChange)="loadReportField($event)"
        [valueNormalizer]="valueNormalizer"
        style=" width:175px ; height: 29px;"
      >
      </kendo-combobox>
    </kendo-floatinglabel>

    <app-mcl-button class="buttonFixedWidth" text="Save Extract" primary="true" [loading]="loadingService.loaderActive===true"
                inprogressMessage="Saving..." [disabled]="loadingService.loaderActive===true"
                (click)="saveExtractList()"></app-mcl-button>
    <app-mcl-button class="buttonFixedWidth" text="Delete Extract" primary="true"
                [loading]="loadingService.loaderActive===true" inprogressMessage="Deleting..."
                [disabled]="loadingService.loaderActive===true"
                (click)="deleteExtractItem()"></app-mcl-button>
  </div>

  <div class="outsideContainer">

    <kendo-grid [data]="extractFields"
                [height]="350"
                [kendoGridSelectBy]="'fieldName'"
                [loading]="loadingService.loaderActive===true"
                [selectedKeys]="fieldsSelected"
                (selectedKeysChange)="keyChangeMove($event)"
                [selectable]="{ checkboxOnly: false, mode: 'multiple' }"
                class="rowGrid">
      <kendo-grid-column [field]="'fieldName'" [title]="'Field Name'" [width]="100"></kendo-grid-column>
    </kendo-grid>

    <div class="grid-commands">
      <app-mcl-button class="buttonFixedWidth" text="Move" primary="true" (click)="moveButtonClicked($event)"></app-mcl-button>
      <app-mcl-button class="buttonFixedWidth" text="Move All" primary="true"
                  (click)="moveAllButtonClicked($event)"></app-mcl-button>
      <app-mcl-button class="buttonFixedWidth" text="Remove" primary="true"
                  (click)="removeButtonClicked($event)"></app-mcl-button>
      <app-mcl-button class="buttonFixedWidth" text="Remove All" primary="true"
                  (click)="removeAllButtonClicked($event)"></app-mcl-button>
    </div>

    <kendo-grid [data]="currentSavedFields"
                class="rowGrid"
                [height]="350"
                [loading]="loadingService.loaderActive===true"
                [kendoGridSelectBy]="'fieldName'"
                [selectedKeys]="fieldsSelectedSelectedGrid"
                (selectedKeysChange)="keyChangeRemove($event)"
                [selectable]="{ checkboxOnly: false, mode: 'multiple' }"
    >
      <kendo-grid-column [field]="'fieldName'" [title]="'Field Name'" filterable="true" sortable="true"
                         [width]="100"></kendo-grid-column>
      <kendo-grid-column [title]="'Order'" editor="numeric" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-numerictextbox [(ngModel)]="dataItem.fieldOrder" (blur)="reorderFields($event)" format="n0"
                                decimals="0"></kendo-numerictextbox>

        </ng-template>
      </kendo-grid-column>

    </kendo-grid>
  </div>

</div>
